<div class="col-lg col-sm-12">
    <div class="row">
        <div class="col-md-12">
            <div class="sort-group">
                <div class="sort">
                    <mat-label>{{consts.LABEL_SORT}}</mat-label>
                    <app-filter-select
                        class="sort-type"
                        [value]="consts.LABEL_SORT_MOST"
                        [options]="sortOptions"
                        placeholder="Sort"
                        [formControl]="sortControl"
                    >
                    </app-filter-select>
                </div>
            </div>
            <div
                class="filter-group"
                [ngClass]="isFiltersDirty() ? 'show-reset-all' : 'hide-reset-all'"
            >
                <div class="filter">
                    <mat-label>{{consts.LABEL_FILTER}}</mat-label>
                    <!--RATING-->
                    <app-filter-select
                        [canSelectAll]="true"
                        class="filter-rating"
                        [options]="ratingOptions"
                        label="Rating"
                        placeholder="{{consts.PLACEHOLDER_FILTER_OPTIONS.RATING}}"
                        [formControl]="ratingControl"
                    >
                        <ng-template
                            #selectTemplate
                            let-option
                        >
                            {{option === consts.ONE_RATING ? option + consts.LABEL_STAR : option + consts.LABEL_STARS}}
                            <mat-icon
                                class="star-rating"
                                svgIcon="hub_star_filled"
                            >
                            </mat-icon>
                        </ng-template>
                        <ng-template
                            #optionTemplate
                            let-option
                        >
                            {{option === consts.ONE_RATING ? option + consts.LABEL_STAR : option + consts.LABEL_STARS}}
                            <mat-icon
                                class="star-rating"
                                svgIcon="hub_star_filled"
                            >
                            </mat-icon>
                        </ng-template>
                    </app-filter-select>
                    <!--KNOWLEDGE BASE-->
                    <app-filter-select
                        [canSelectAll]="true"
                        class="filter-kb"
                        [options]="kbOptions"
                        label="Knowledge Base"
                        placeholder="{{consts.PLACEHOLDER_FILTER_OPTIONS.KB}}"
                        [formControl]="kbControl"
                    >
                    </app-filter-select>
                    <!--CATEGORY-->
                    <app-filter-select
                        [canSelectAll]="true"
                        class="filter-category"
                        [options]="categoryOptions"
                        label="Category"
                        placeholder="{{consts.PLACEHOLDER_FILTER_OPTIONS.CATEGORY}}"
                        [formControl]="categoryControl">
                    </app-filter-select>
                </div>
            </div>
            <div
                *ngIf="isFiltersDirty()"
                class="clear-filter"
            >
                <button
                    mat-flat-button
                    class="clear-button"
                    (click)="clearFilters(true)"
                >
                    {{consts.RESET_FILTERS}}
                </button>
            </div>
        </div>
    </div>
    <div class="row col-lg col-md-12 col-sm-12 trending-it">
        <div 
            class="no-results" 
            *ngIf="(articleList$ | async)?.length === 0"
        >
            {{consts.NO_RESULTS}}
        </div>
        <ng-container *ngIf="articleList$ | async as articles; else loading">
            <ng-container *ngIf="!isLoading; else loading">
                <div *ngFor="let article of articles | slice: 0:consts.MAX_ARTICLE_COUNT">
                    <div class="article-container">
                        <app-trending-list-item
                            [title]="article.shortdescription"
                            [url]="article.updatedurl"
                            [lastUpdatedBy]="article.sysupdatedon"
                            [rating]="article.rating"
                            [viewCount]="article.sysviewcount"
                            [summary]="article.previewContent"
                            [additionalInfo]="[{
                                propertyLabel: consts.ARTICLE_INFO.KB,
                                propertyValue: article.kbknowledgebase
                            }, {
                                propertyLabel: consts.ARTICLE_INFO.CATEGORY,
                                propertyValue: article.kbcategory
                            }]"
                        >
                        </app-trending-list-item>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #loading>
            <div class="loading-spinner text-center">
                <mat-spinner [diameter]="30"></mat-spinner>
            </div>
        </ng-template>
    
    </div>
    <div class="row">
        <div class="col-md-12">
            <div
                class="trending-footer text-center"
                (click)="openLink()"
            >
                <span>{{consts.FOOTER_TEXT}}</span>
                <mat-icon
                    svgIcon="hub_round_arrow"
                    class="go-to"
                >
                </mat-icon>
            </div>
        </div>
    </div>
</div>
